export default "__VITE_PUBLIC_ASSET__474c79b3__"